
import { toast as sonnerToast } from 'sonner';

// Create a properly typed toast function
export const toast = sonnerToast;

// Create a hook that returns the toast function
export const useToastWrapper = () => {
  return {
    toast: sonnerToast
  };
};
